module.exports = __webpack_public_path__ + "public/Icons/editIcon.svg?edef8462";